document.addEventListener("DOMContentLoaded", function () {
  // Remove link in the cart drawer. Without this it followed
  // /cart/change?quantity=0 to the cart page; the theme's quantity handler
  // also ignores 0, so this is the drawer's only way to drop a line.
  document.addEventListener("click", function (e) {
    const link = e.target.closest && e.target.closest("#CartDrawer .cart__remove a");
    if (!link) return;
    const item = link.closest("[data-key]");
    if (!item) return;
    e.preventDefault();
    // Take the line out straight away; the response carries the rebuilt
    // drawer section (items, totals), so no second request is needed.
    item.style.display = "none";
    const drawer = document.getElementById("CartDrawer");
    if (drawer) drawer.classList.add("is-updating");
    const section = (window.theme && theme.cart && theme.cart.drawerSection) || "cart-ajax";
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || "/") + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: item.dataset.key, quantity: 0, sections: section }),
    })
      .then((res) => res.json())
      .then((cart) => {
        document.dispatchEvent(new CustomEvent("cart:build", { detail: { sections: cart.sections } }));
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart } }));
      })
      .catch(() => { window.location = link.href; });
  });

  // While the bag is open, a drag that nothing inside it can scroll would
  // move the page underneath (iOS ignores overflow: hidden on the page for
  // touch). Let a drag through only when the drawer element under the
  // finger can still scroll that way; cancel everything else.
  let touchX = 0;
  let touchY = 0;
  document.addEventListener("touchstart", function (e) {
    if (e.touches.length !== 1) return;
    touchX = e.touches[0].clientX;
    touchY = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener("touchmove", function (e) {
    const drawer = document.getElementById("CartDrawer");
    if (!drawer || !drawer.classList.contains("drawer--is-open") || e.touches.length !== 1) return;
    // A quick view opened from the drawer sits above it and scrolls itself.
    if (e.target.closest && e.target.closest(".iwa-qv")) return;
    const dx = e.touches[0].clientX - touchX;
    const dy = e.touches[0].clientY - touchY;
    const vertical = Math.abs(dy) >= Math.abs(dx);
    for (let el = e.target; el && el !== drawer && drawer.contains(el); el = el.parentElement) {
      const style = getComputedStyle(el);
      if (vertical && /(auto|scroll)/.test(style.overflowY) && el.scrollHeight > el.clientHeight + 1) {
        const atTop = el.scrollTop <= 0;
        const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
        if ((dy > 0 && !atTop) || (dy < 0 && !atBottom)) return;
      }
      if (!vertical && /(auto|scroll)/.test(style.overflowX) && el.scrollWidth > el.clientWidth + 1) return;
    }
    if (e.cancelable) e.preventDefault();
  }, { passive: false });
});
